import { AvaiableProductsResult } from "../types/AvailableProducts";

interface Props {
  availableProducts: AvaiableProductsResult;
}

export const HouseBox = ({ availableProducts }: Props) => {
  return (
    <>
      {availableProducts.results.length > 0 ? (
        <div>
          <div className="text-2xl text-gray-600 mb-4">
            Här är vad vi kan hjälpa dig med
          </div>
          <div
            className="w-full relative p-8 flex flex-col justify-center items-center text-center gap-4 text-white rounded-md"
            id="order-popup-content"
            style={{
              backgroundSize: "cover",
              backgroundImage: `url("https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80")`,
              backgroundPosition: "50% 75%",
            }}
          >
            <div className="absolute inset-0 bg-black/40 rounded-md" />
            <div className="z-10 flex flex-col justify-center text-center space-y-8 items-center">
              <span className="text-3xl font-normal">
                Se vad vi kan erbjuda på adressen och gör en beställning direkt!
              </span>
              <a href={`/order/?q=${availableProducts.useplace.id}`}>
                <button className="bg-primary-500 px-8 py-1">
                  Visa tillgängligt utbud
                </button>
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-2xl text-gray-600 mb-4">
            Här är vad vi kan hjälpa dig med
          </div>
          <div
            className="w-full relative bg-yellow-200 p-8 flex flex-col justify-center items-center text-center gap-4 no-result rounded-md"
            id="order-popup-content"
            style={{
              backgroundSize: "cover",
              backgroundImage: `url("https://images.unsplash.com/photo-1517685352821-92cf88aee5a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80")`,
              backgroundPosition: "50% 45%",
            }}
          >
            <div className="absolute inset-0 bg-black/40 rounded-md" />
            <div className="z-10 flex flex-col justify-center text-center space-y-8 items-center">
              <span className="text-3xl font-normal text-white font-sans">
                Just nu finns inga beställningsbara tjänster på vald adress
              </span>
              <span className="text-white font-sans">
                Har du sökt på en lägenhet ber vi dig att kontakta din hyresvärd
                för att få information om vilken lösning som erbjuds på adresen.
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
